<!--管理用户管理-->
<template>
  <div>
    <Modal
      loading
      transfer
      @on-ok="onOK"
      @on-cancel="hidedenModal"
      ref="Modal"
      :title="title"
      >
      <Layout>
        <h4 class="iv-m-b-16">
          精确查找党员信息
          <span style="color: red; font-weight: normal;" class="iv-fs-14">（输入姓名及其他其中一个条件才能查询，且查询为精确查询。）</span>
        </h4>
        <tagGroup
          :list="checkListLable"
          class="iv-m-b-16"
          @onClose="onTagClose" />
        <SearchLayout
          isNest
          :spreadType="2"
          :list="searchList"
          @on-search="onSearch"
          searchBtText="查询" 
        />
        <Table
          v-show="showTable"
          ref="Table"
          :noSearch="noSearch"
          autoHeight
          :showTree="false"
          :showEdit="false"
          :showDelete="false"
          :showSetButton="false"
          @on-selection-change="onSelectionChange"
          @on-select-cancel="onSelectCancel"
          :showSelect="showSelect"
          :showPage="showPage"
          @on-list="onList"
          @on-radio-change="onRadioChange"
          :showRadioSelect="showRadioSelect"
          :menuName="menuName"
          :listData="listDataTable"
          :url="listEditUrl"
          :getAction="getAction"
          :columns="columns">
        </Table>
      </Layout>
    </Modal>
  </div>
</template>
<script>
import Modal from '@/components/modal'
import Table from '@/components/drag-table-inline'
import Layout from '@/components/modal/layout'
import columnsMember from './columnsMember'
import SearchLayout from '@/components/search-layout'
import tagGroup from '@/components/tag-group'
export default {
  props: {
    getAction: {
      type: Function
    },
    listData: {
      type: Object,
      default () {
        return {}
      }
    },
    listUrl: {
      type: String,
      default: ''
    },
    defaultValue: {
      type: Array,
      default () {
        return []
      }
    },
    customColumns: {
      type: Array,
      default () {
        return []
      }
    },
    showPage: {
      type: Boolean,
      default: true
    },
    noSearch: {
      type: Boolean,
      default: true
    },
    showRadioSelect: { //单选
      type: Boolean,
      default: false
    },
    showSelect: { //多选
      type: Boolean,
      default: true
    },
    map: {
      type: Object,
      default () {
        return {
          value: 'value', // 用于操作的值key名
          title: 'title' // 用于显示的值key名
        }
      }
    },
    multiple: {
      type: Boolean,
      default: true
    },
    menuName: {
      type: String,
      default: 'selectMemberDefaultCode'
    },
    title: {
      type: String,
      default: '选人'
    }
  },
  data () {
    return {
      listDataTable: {},
      columns: [],
      onListData: [], // 所有数据
      onCurrentListData: [], // 当前页数据
      value: [],
      list: [],
      searchList: [],
      checkList: [], // 已选列表id
      checkListLable: [], // tag 列表
      listEditUrl: '', // 列表url
      showTable: false
    }
  },
  components: {
    Table,
    Modal,
    Layout,
    SearchLayout,
    tagGroup
  },
  created () {
    this.initDefaultValue(this.defaultValue)
    this.setDefaultTable()
  },
  watch: {
    defaultValue: {
      handler (val) {
        this.initDefaultValue(val)
      },
      deep: true,
      immediate: true
    }
  },
  inject: {
    expandParent: {
      default () {
        return function () {}
      }
    }
  },
  methods: {
    // 初始化table
    setDefaultTable () {
      if (this.listUrl.includes('api-general/module/portal/user/listOrganizationUser') || this.listUrl.includes('module/user/getUserList')) {
        this.listEditUrl = 'precisequery/preciseQueryUser'
        return
      }
      this.listEditUrl = this.listUrl
    },
    initDefaultValue (val) {
      if (Array.isArray(val) && val.length) {
        this.checkListLable = val.map(item => item[this.map.title])
        this.checkList = this.showSelect ? val.map(item => item[this.map.value]) : val[0][this.map.value]
        val.forEach(item => {
          let isHas = this.onListData.find(pag => pag[this.map.value] === item[this.map.value])
          if (!isHas) {
            this.onListData.push(item)
          }
        })
      }
    },
    // 获取列表数据
    onList (data) {
      this.onCurrentListData = data
      if (this.onListData.length) {
        data.forEach(item => {
          let isHas = this.onListData.find(pag => pag[this.map.value] === item[this.map.value])
          if (!isHas) {
            this.onListData.push(item)
          }
        })
      } else {
        this.onListData = data
      }
      // 回显选中数据
      if (this.checkList.length) {
        this.checkList.forEach(item => {
          let inx = data.findIndex(p => p[this.map.value] === item)
          if (inx >= 0) {
            this.$nextTick(() => {
              this.$refs.Table.$refs.Table.toggleSelect(inx)
            })
          }
        })
      }
    },
    // 选择事件
    onSelectCancel (list, row) {
      let index = this.checkList.findIndex(item => row[this.map.value] === item)
      this.checkList.splice(index, 1)
      this.checkListLable.splice(index, 1)
    },
    //多选事件
    onSelectionChange (list) {
      if (!list.length) {
        this.onCurrentListData.forEach(item => {
          const ind = this.checkList.findIndex(p => (p === item[this.map.value]))
          if (ind >= 0) {
            this.checkList.splice(ind, 1)
            this.checkListLable.splice(ind, 1)
          }
        })
      }
      list.forEach(item => {
        if (!this.checkList.includes(item[this.map.value])) {
          this.checkList.push(item[this.map.value])
          this.checkListLable.push(item[this.map.title])
        }
      })
    },
    //单选事件
    onRadioChange (list) {
      //解决 修改回显后，点击其他单选。radio框都显示的问题
      this.onListData.forEach(element => {
        element._checked = false
      })
    },
    // 显示模态框
    onShow () {
      this.initTable()
      this.initDefaultValue(this.defaultValue)
      this.$methods('Modal', 'open')
    },
    //模态框隐藏
    hidedenModal () {
      this.checkList.length = 0
      this.checkListLable.length = 0
      this.onListData.length = 0
      this.showTable = false
      this.$Modal.remove()
    },
    // 关闭
    onCancel () {
      this.$methods('Modal', 'close')
    },
    // 保存
    onOK () {
      let _arr = [], _allArr = []
      this.onListData.forEach(item => {
        if (this.checkList.includes(item[this.map.value])) {
          _arr.push({
            [this.map.title]: item[this.map.title],
            [this.map.value]: item[this.map.value]
          })
          _allArr.push(item)
        }
      })
      this.$emit('on-process-data', _arr, 'table', _allArr)
      this.onCancel()
    },
    // 搜索
    onSearch (params, type) {
      if (!type) return
      if (type !== 'reset') {
        if (!params.userName) return this.$Message.error('姓名为必填项！')
        if (!params.idCardNum && !params.phone && !params.zzbCode) {
          return this.$Message.error('输入姓名及其他一个条件才能查询！')
        }
        this.showTable = true
        this.listDataTable = Object.assign({}, params)
        this.$methods('Table', 'forceRender')
        return
      }
      this.showTable = false
      this.initTable()
    },
    // tag点击
    onTagClose (v, index) {
      const ind = this.onListData.findIndex(item => (item[this.map.value] === this.checkList[index] && item[this.map.title] === v))
      if (ind >= 0 && this.showTable) {
        this.$refs.Table.$refs.Table.toggleSelect(ind)
        return
      }
      this.checkList.splice(index, 1)
      this.checkListLable.splice(index, 1)
    },
    // 初始化列表
    initTable () {
      this.onListData.length = 0
      if (this.listUrl.includes('api-general/module/portal/user/listOrganizationUser') || this.listUrl.includes('module/user/getUserList')) {
        this.listDataTable = {}      
        this.listEditUrl = 'precisequery/preciseQueryUser'
      } else {
        this.listDataTable = Object.assign({}, this.listData)
        this.listEditUrl = this.listUrl
      }
      this.columns = this.customColumns.length ? this.customColumns : columnsMember.call(this)
      this.searchList = [
        {
          label: '姓名',
          type: 'Input',
          name: 'userName',
          placeholder: '必填，全名查询'
        },
        {
          label: '身份证号',
          type: 'Input',
          name: 'idCardNum',
          placeholder: '后四位精确查询'
        },
        {
          label: '手机号',
          type: 'Input',
          name: 'phone',
          placeholder: '后四位精确查询'
        },
        {
          label: '党支部中组部编码',
          type: 'Input',
          name: 'zzbCode',
          placeholder: '精确查询'
        }
      ]
    }
  }
}
</script>
<style scoped lang="scss">
/deep/ .iv-search-container {
  .iv-label {
    margin-top: 4px !important;
  }
}
</style>